import {SearchParametersModel} from "../store/reducers/search";
import store from "../store/store";
import {WorkPackage} from "../models/responses/work-package.model";

const filterWorkPackages = (
    wp: WorkPackage | undefined,
    searchParams: SearchParametersModel,
) => {
    if (!wp) {
        return false;
    }
    if (!searchParams.chipList.length &&
        !searchParams.searchText &&
        !searchParams.taskForces.length &&
        !searchParams.startDate &&
        !searchParams.finishDate &&
        !searchParams.alert &&
        !searchParams.noTaskForce &&
        !searchParams.taskOwner &&
        !searchParams.workPackage
    ) {
        return true;
    }
    let filtering = true;

    if (searchParams.workPackage && searchParams.workPackage.workPackageId !== wp.workPackageId) {
        filtering = false;
    }

    if (searchParams.noTaskForce) {
        if (wp.workPackageOwner) {
            const taskOwnerMember = store.getState().team.memberList
                // @ts-ignore
                .concat(store.getState().team.pendingMemberList)
                .find(member => member.userId === wp.workPackageOwner || member.userEmail === wp.workPackageOwner);
            if (taskOwnerMember && !taskOwnerMember.leftProject) {
                return false;
            }
        }
    }

    if (searchParams.alert) {
        if (wp.overdueChecklistItemsCount === 0 || !wp.overdueChecklistItemsCount) {
            filtering = false;
        }
    }

    if (searchParams.chipList.length) {
        filtering = searchParams.chipList.every(
            (chip) =>
                wp.workPackageRef.toLowerCase().includes(chip.text.toLowerCase()) ||
                wp.workPackageName.toLowerCase().includes(chip.text.toLowerCase()) ||
                (wp.workPackageDescription &&
                    wp.workPackageDescription.toLowerCase().includes(chip.text.toLowerCase()))
        );
    }

    if (searchParams.startDate || searchParams.finishDate) {
        if (!wp.packageStart || !wp.packageEnd) {
            filtering = false;
        }
        else if (searchParams.startDate) {
            if (searchParams.finishDate) {
                if (wp.packageStart > searchParams.finishDate || wp.packageEnd < searchParams.startDate) {
                    filtering = false;
                }
            } else {
                if (wp.packageEnd < searchParams.startDate) {
                    filtering = false;
                }
            }
        } else {
            if (wp.packageStart > searchParams.finishDate!) {
                filtering = false;
            }
        }
    }
    if (filtering && searchParams.searchText) {
        // @ts-ignore
        filtering =
            wp.workPackageRef
                .toLowerCase()
                .includes(searchParams.searchText.toLowerCase()) ||
            wp.workPackageName
                .toLowerCase()
                .includes(searchParams.searchText.toLowerCase()) ||
            (wp.workPackageDescription &&
                wp.workPackageDescription
                    .toLowerCase()
                    .includes(searchParams.searchText.toLowerCase()));
    }
    if (filtering && searchParams.taskForces.length && searchParams.taskOwner.length) {
        if (!wp.workPackageOwner && wp.workPackageTaskForce?.length === 0) {
            return false;
        }
        filtering = searchParams.taskForces.some((el) =>
            wp.workPackageTaskForce?.includes(el[0]) || wp.workPackageTaskForce?.includes(el[1])
        );
        filtering = filtering || wp.workPackageOwner === searchParams.taskOwner[0] || wp.workPackageOwner === searchParams.taskOwner[1];
    }
    else if (filtering && searchParams.taskForces.length) {
        if (wp.workPackageTaskForce?.length === 0) {
            return false
        }
        filtering = searchParams.taskForces.some((el) =>
            wp.workPackageTaskForce?.includes(el[0]) || wp.workPackageTaskForce?.includes(el[1])
        );
    }
    else if (filtering && searchParams.taskOwner.length) {
        if (!wp.workPackageOwner || !(wp.workPackageOwner === searchParams.taskOwner[0] || wp.workPackageOwner === searchParams.taskOwner[1])) {
            return false;
        }
    }
    return filtering;
};

export default filterWorkPackages;
